import { ComponentType } from 'react';
import { Skin } from '../types/enums';
import { useSkin } from '../contexts/SkinContext';

export type SkinComponentMap<P = object> = Partial<Record<Skin, ComponentType<P>>>;

export function createSkinComponent<P extends object>(
  DefaultComponent: ComponentType<P> | null,
  skinOverrides: SkinComponentMap<P> = {}
): ComponentType<P> {
  const SkinnedComponent: ComponentType<P> = (props) => {
    const { skin } = useSkin();
    const Component = skinOverrides[skin] ?? DefaultComponent;

    if (!Component) return null;

    return <Component {...props} />;
  };

  return SkinnedComponent;
}
